import { useMutation, useQueryClient } from "@tanstack/react-query";

import { toast } from "@performyard/py-components";

import { applyTemplateLibraryEntry } from "../../../api/services/defs/template-library";

export const useApplyTemplateLibraryEntry = () => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: (entryId: string) => applyTemplateLibraryEntry(entryId),
		onSuccess: () => {
			// review_form list (api/queries/defs/forms.ts).
			queryClient.invalidateQueries({ queryKey: ["review-forms"] });
			// survey list fetches through the shared search-service cache; mirrors
			// the pattern in api/hooks/defs/surveys.ts after survey mutations.
			queryClient.invalidateQueries({ queryKey: ["search-service"] });
			// review_workflow and pdf_guide lists are not react-query backed today,
			// so admins are told to refresh the destination page in the success UI.
		},
		onError: () => {
			toast.error("Copy failed");
		},
	});
};
